export const ENTERROOM = 'ENTERROOM';
export const SETDEVICE = 'SETDEVICE';
// export const GETCHARACTER = 'GETCHARACTER';


// WEBPACK FOOTER //
// ./src/store/mutations_type.js